// KPI Card Component
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const KPICard = ({ title, value, icon: Icon, color = "text-cyan-400" }) => {
  return (
    <Card className="bg-[#0A0A0A] border-white/10">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-gray-400">
          {title}
        </CardTitle>
        {Icon && <Icon className={`h-4 w-4 ${color}`} />}
      </CardHeader>
      <CardContent>
        <div className={`text-2xl font-bold ${color}`}>
          {typeof value === 'number' ? value.toLocaleString() : value}
        </div>
      </CardContent>
    </Card>
  );
};

export default KPICard;
